import { ExperienceVerificationStatusType } from '@apply/constants';

export const formatExperienceStatus = (experienceVerificationStatusTypeId: ExperienceVerificationStatusType) => {
    let currentStatus;
    let fontColor = '#000000';
    switch (experienceVerificationStatusTypeId) {
        case ExperienceVerificationStatusType.Rejected:
        case ExperienceVerificationStatusType.UnableToVerify:
            currentStatus = 'Failed';
            fontColor = '#C80000';
            break;
        case ExperienceVerificationStatusType.Submitted:
            currentStatus = 'Submitted';
            break;
        case ExperienceVerificationStatusType.Verified:
            currentStatus = 'Verified';
            break;
    }

    return <span style={{ color: fontColor }}>{currentStatus ?? 'Unknown'}</span>;
};
